// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"537472d2","309":"5595310b","449":"f0678d26","456":"68ad4590"}[chunkId] + ".chunk.css";
};